// EmailJS Configuration
// Follow these steps to set up EmailJS:

// 1. Go to https://www.emailjs.com/
// 2. Create a free account
// 3. Add an email service (Gmail, Outlook, Yahoo, etc.)
// 4. Create an email template
// 5. Replace the values below with your actual EmailJS credentials

export const emailjsConfig = {
  // Your Service ID from EmailJS dashboard
  serviceId: 'service_ht8lxua',
  
  // Your Template ID from EmailJS dashboard  
  templateId: 'template_rj9qg1g',
  
  // Your Public Key from EmailJS dashboard
  publicKey: 'Iwg4jILms2zMQn_u6'
};

// Example template variables you can use in your EmailJS template:
// {{from_name}} - Customer's name
// {{from_email}} - Customer's email
// {{from_phone}} - Customer's phone
// {{message}} - Customer's message
// {{to_name}} - Your business name
// {{timestamp}} - When the message was sent